import { AssetsImportedEvent } from '../event/assets-imported.event';
const assetsImportedProjections = {
    [AssetsImportedEvent.name]: (event, state) => ({
        ...state,
    }),
};
export default assetsImportedProjections;
//# sourceMappingURL=assets-imported.projection.js.map